import { Fragment } from 'react';
import PropTypes from 'prop-types';
import SocialShare from '~/js/modules/share-social';
import QuickQuote from '~/js/components/QuickQuote';

const { userAgent } = window.navigator;
const internals = {
    msie: userAgent.indexOf('MSIE'),
    edge: userAgent.indexOf('Edge'),
    trident: userAgent.indexOf('Trident')
};

const toDataURL = (src, callback, outputFormat) => {
    const img = new Image();

    img.crossOrigin = 'Anonymous';

    img.onload = function onloadFunc() {
        const canvas = document.createElement('CANVAS');
        const ctx = canvas.getContext('2d');

        canvas.height = this.naturalHeight;
        canvas.width = this.naturalWidth;
        ctx.drawImage(this, 0, 0);

        callback(canvas.toDataURL(outputFormat));
    };

    img.src = src;

    if (img.complete || img.complete === undefined) {
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
        img.src = src;
    }
};

const downloadHandler = (e) => {
    const { target } = e;
    const { msie, edge, trident } = internals;

    if (msie < 0 || edge < 0 || trident < 0) {
        e.preventDefault();

        toDataURL(target.parentNode.href,
            (dataUrl) => {
                const downloadLink = document.createElement('a');

                downloadLink.href = dataUrl;
                downloadLink.setAttribute('download', 'event-image');
                downloadLink.click();
            }
        );
    }
};

const pinterestShareHandler = (e, img) => {
    e.preventDefault();

    const { target } = e;
    const ogDescription = $("meta[property='og:description']").attr('content');

    const params = {
        link: location.href,
        img: `//www.sandals.com${img}`,
        title: ogDescription
    };

    const link = SocialShare.generateUrl('https://pinterest.com/pin/create/bookmarklet/?media={img}&url={link}&is_video={is_video}&description={title}', params);

    target.parentNode.href = link;

    SocialShare.doPopup(e, link);
};

const facebookShareHandler = (e) => {
    e.preventDefault();

    const { target } = e;
    const ogDescription = $("meta[property='og:description']").attr('content');
    const ogImg = $("meta[property='og:image']").attr('content');

    const params = {
        link: location.href,
        redirect_url: location.origin,
        img: ogImg,
        desc: ogDescription,
        app_id: '150389325070106'
    };

    const link = SocialShare.generateUrl('https://www.facebook.com/sharer.php?s=100&p[url]={link}&p[images][0]={img}&p[title]={title}&p[summary]={desc}', params);

    target.parentNode.href = link;

    SocialShare.doPopup(e, link);
};

const DetailsView = (props) => {
    const {
        data: {
            eventId = '',
            groupId = '',
            rstCode = '',
            rstCodes = [],
            eventName = '',
            groupName = '',
            mainImages = {},
            livPlusEventDate,
            resortInfo,
            modalContent,
            description = '',
            padiIncludes = [],
            rates = [],
        },
        onBackClicked
    } = props;
    const { cdnURL } = window.sandals_app.page;

    let eventDescription = <p>{description}</p>;
    let imageElement = <div className="img-placeholder"><span>No image</span></div>;
    let includes = null;

    if (modalContent) {
        eventDescription = (
            <div
                className="text"
                dangerouslySetInnerHTML={{ __html: modalContent }} />
        );
    }

    if (mainImages.modal) {
        imageElement = (
            <Fragment>
                <img
                    src={mainImages.modal}
                    alt={eventName}
                    className="img-responsive"/>
                <figcaption>
                    <div className="share">
                        Share
                        <ul className="link-list">
                            <li className="js-share-facebook">
                                <a
                                    href="https://www.facebook.com/sandalsresorts/"
                                    onClick={facebookShareHandler}>
                                    <i className="ic ic-facebook" />
                                </a>
                            </li>
                            <li className="js-share-pinterest">
                                <a
                                    href="https://www.pinterest.com/sandalsresorts/"
                                    onClick={(e) => pinterestShareHandler(e, mainImages.modal)}>
                                    <i className="ic ic-pinterest" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="download">
                        Download
                        <ul className="link-list">
                            <li className="js-share-pinterest">
                                <a
                                    href={mainImages.modal}
                                    target="_blank"
                                    onClick={downloadHandler}>
                                    <i className="ic ic-download" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </figcaption>
            </Fragment>
        );
    }

    if (padiIncludes.length) {
        includes = (
            <div className="includes">
                <h3 className="title-4">Diving package includes:</h3>
                <ul className="includes-list">
                    {padiIncludes.map((el, index) => (
                        <li key={index}>{el}</li>
                    ))}
                </ul>
            </div>
        );
    }

    return(
        <div className="details container">
            <div className="details-inner">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="details-content">
                            <h2 className="title-6">{eventName}</h2>
                            <h3 className="title-7">{groupName}</h3>
                            <button className="back-btn" onClick={onBackClicked}>
                                <i className="ic ic-button-arrow-prev" />
                                Back To lIV+ Events
                            </button>

                            <figure>
                                {imageElement}
                            </figure>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-lg-7">
                        <div className="description">
                            <h3 className="title-4">{livPlusEventDate}</h3>

                            {eventDescription}
                        </div>

                        {includes}
                    </div>
                    <div className="details-aside col-xs-12 col-sm-6 col-lg-4">
                        <img
                            src={`${cdnURL}/images/general/liv-plus/liv-logo.svg`}
                            alt="Luxury included holiday + events" />
                        <div className="price">
                            ${rates[0].rate} <span>per person <span className="show">(USD)</span></span>
                        </div>
                        <QuickQuote
                            resortsPlaceholder={(!rstCodes.length && resortInfo) || false}
                            reference="oee"
                            groupID={groupId}
                            eventID={eventId}
                            brand="all"
                            allowedResortCodes={rstCodes}
                            defaultResortCode={!rstCodes.length && rstCode}
                            schedulerModeIndex={15}
                            hasCountries={false}
                            quoteButtonText="Continue"
                            hasResorts
                            resortDisabled={!rstCodes.length}
                        />
                    </div>
                </div>
            </div>

            <button className="back-btn" onClick={onBackClicked}>
                <i className="ic ic-button-arrow-prev" />
                Back To lIV+ Events
            </button>
        </div>
    );
};

DetailsView.propTypes = {
    data: PropTypes.object,
    onBackClicked: PropTypes.func,
};

DetailsView.defaultProps = {
    data: {},
    onBackClicked: () => {}
};

export default DetailsView;
